import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { setCurrentLegalFormAction } from 'store/actions/searchTab';
import { getText } from 'services/languageService';
import {
  Autocomplete,
  AutocompleteChangeReason,
  AutocompleteValue,
  Chip,
  TextField,
} from '@mui/material';

export const ListLegalForms: React.FC = () => {
  const [inputValue, setInputValue] = useState<string>(' ');
  const [form, setForm] = useState([]);
  const { listLegalForms, currentLegalForm } = useAppSelector(
    (state) => state.searchTab
  );
  const dispatch = useAppDispatch();

  const handleChangeInput = (
    event: SyntheticEvent<Element, Event>,
    newValue: string
  ) => {
    setInputValue(newValue);
  };

  const handleChangeSelect = (
    event: SyntheticEvent<Element, Event>,
    value: AutocompleteValue<any, any, any, any> | null,
    reason: AutocompleteChangeReason
  ) => {
    const ids = value.map((v) => v.code);
    setForm(value);
    ids.length
      ? dispatch(setCurrentLegalFormAction(ids))
      : dispatch(setCurrentLegalFormAction([]));
  };

  useEffect(() => {
    if (currentLegalForm.length) {
      const curLayer = listLegalForms.filter((item) =>
        currentLegalForm.includes(+item.code)
      );
      // @ts-ignore
      curLayer && setForm(curLayer);
    }
  }, [listLegalForms]);

  return (
    <Autocomplete
      multiple
      limitTags={1}
      value={form}
      inputValue={inputValue}
      id="controllable-states-demo"
      size={'small'}
      fullWidth
      options={listLegalForms}
      onChange={handleChangeSelect}
      onInputChange={handleChangeInput}
      sx={{ mb: 1, p: '8px 16px 0 16px' }}
      renderOption={(props, option) => {
        return (
          <li {...props} key={option.code}>
            {option.name}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField label={getText('LIST_LEGAL_FORM_TITLE')} {...params} />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            size="small"
            label={
              option.name.length > 30
                ? `${option.name.slice(0, 30)}...`
                : option.name
            }
            {...getTagProps({ index })}
          />
        ))
      }
    />
  );
};
